import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

interface Props {
  isMobile: boolean;
  title: string;
  handleOpenShareModal: () => void;
}

const NonBenefitPharmacyHeader = (props: Props) => {
  return (
    <div className={'z-[2] bg-white'}>
      {props.isMobile ? (
        <header className={'flex items-center justify-between px-6 pb-5'}>
          <h1 className={'typography-ui-22sb'}>{props.title}</h1>
          <button onClick={props.handleOpenShareModal}>
            <MaterialIcon name={'share'} color={theme.color.gray600} size={24} />
          </button>
        </header>
      ) : (
        <header className='flex h-12 items-center justify-between px-5 py-0'>
          <h1 className={'typography-ui-22sb'}>{props.title}</h1>
          <button
            type={'button'}
            onClick={props.handleOpenShareModal}
            className='typography-ui-16sb flex flex h-12 items-center items-center gap-2 rounded-lg border border-gray-100 border-solid px-5'
          >
            <MaterialIcon name={'share'} color={theme.color.gray600} size={20} />
            공유하기
          </button>
        </header>
      )}
    </div>
  );
};

export default NonBenefitPharmacyHeader;
